import graphql__5a7607e1db821f68ee1b from "./__generated__/PageSectionSidebarParticipativeModuleResults_pageSection.graphql.js";import { Suspense } from "react";
import { graphql, useFragment } from "react-relay";

import PageSectionSidebarBlock from "./PageSectionSidebarBlock";
import ParticipativeModuleResultsFormFields from "../ParticipativeModuleResultsFormField/ParticipativeModuleResultsFormFields";
import Spinner from "../Utils/Spinner";

const PageSectionSidebarParticipativeModuleResults = props => {
  const pageSection = useFragment(
    PageSectionSidebarParticipativeModuleResults_pageSection,
    props.pageSection
  );
  const {
    title,
    description,
    iconClass,
    displayQuestionsLabel,
    displayParticipationData,
    results
  } = pageSection;

  if (!results || results.length === 0) return null;

  const formFieldsTitleLevel = title && title !== "" ? "h3" : "h2";

  return (
    <div className="container page-section page-section-calendar">
      <PageSectionSidebarBlock
        title={title}
        description={description}
        iconClassName={iconClass}
      >
        <div className="padding-md">
          <Suspense fallback={<Spinner className="padding-md" />}>
            <ParticipativeModuleResultsFormFields
              pageSection={pageSection}
              displayQuestionsLabel={displayQuestionsLabel}
              displayParticipationData={displayParticipationData}
              TitleLevel={formFieldsTitleLevel}
            />
          </Suspense>
        </div>
      </PageSectionSidebarBlock>
    </div>
  );
};

const PageSectionSidebarParticipativeModuleResults_pageSection = graphql__5a7607e1db821f68ee1b;

export default PageSectionSidebarParticipativeModuleResults;
